import React, { useState } from 'react'
 
 
import GatePassOutList from './GatePassOutList';
import GatePassOutForm from './GatePassOutForm';

const GatePassOut= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <GatePassOutForm addForm={setFromIsShown} update={upData} />
        ) : (
          <GatePassOutList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default GatePassOut